import * as actionTypes from "../actionTypes";
import * as constants from "../Constatnts";
import axios from "axios";

export function addNewProductCategory(productCategory) {
  return async (dispatch, getState) => {
    try {
      const user = getState().user.user;
      const payload = {
        ...productCategory,
      };

      const token = getState().user.uat;
      const response = await axios.post(
        constants.API_URL + "/catalog/categories",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("addNewProductCategory", response);
      response.data.message = "Category saved successfully";
      return response.data;
    } catch (error) {
      return {
        code: "1",
        message: "Error adding product category",
        category: null,
      };
    }
  };
}

export function updateProductCategory(key, productCategory) {
  return async (dispatch, getState) => {
    try {
      const user = getState().user.user;
      const payload = {
        ...productCategory,
      };

      const token = getState().user.uat;
      const response = await axios.put(
        constants.API_URL + "/catalog/categories/" + key,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("updateProductCategory", response);
      response.data.message = "Category updated successfully";
      return response.data;
    } catch (error) {
      return {
        code: "1",
        message: "Error updating product category",
        category: null,
      };
    }
  };
}

export function deleteProductCategory(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.delete(
        constants.API_URL + "/catalog/categories/" + key,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === "0") {
        alert("Category Deleted Successfully");
      } else {
        alert("Failed to delete category");
      }

      return response.data;
    } catch (error) {
      return {
        code: "1",
        message: "Error deleting product category",
        category: null,
      };
    }
  };
}

export function addNewProductSubCategory(productCategory) {
  return async (dispatch, getState) => {
    try {
      const user = getState().user.user;
      const payload = {
        ...productCategory,
      };

      const token = getState().user.uat;
      const response = await axios.post(
        constants.API_URL + "/catalog/subcategories",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("addNewProductSubCategory", response);
      response.data.message = "Sub category saved successfully";
      return response.data;
    } catch (error) {
      return {
        code: "1",
        message: "Error adding product sub category",
        category: null,
      };
    }
  };
}

export function updateProductSubCategory(key, productCategory) {
  return async (dispatch, getState) => {
    try {
      const user = getState().user.user;
      const payload = {
        ...productCategory,
      };

      const token = getState().user.uat;
      const response = await axios.put(
        constants.API_URL + "/catalog/subcategories/" + key,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("updateProductSubCategory", response);
      response.data.message = "Sub category updated successfully";
      return response.data;
    } catch (error) {
      return {
        code: "1",
        message: "Error updating product sub category",
        category: null,
      };
    }
  };
}

export function deleteProductSubCategory(key) {
  return async (dispatch, getState) => {
    try {
      const user = getState().user.user;
      const token = getState().user.uat;
      const response = await axios.delete(
        constants.API_URL + "/catalog/subcategories/" + key,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("deleteProductSubCategory", response);
      response.data.message = "Sub category deleted successfully";
      return response.data;
    } catch (error) {
      return {
        code: "1",
        message: "Error deleting product sub category",
        category: null,
      };
    }
  };
}

// export function getProductCategories() {
//   return async (dispatch, getState) => {
//     try {
//       const token = getState().user.uat;
//       const response = await axios.get(
//         constants.API_URL + "/catalog/categories",
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       const productCategories = response.data.productCategories;
//       console.log("productCategories", productCategories);
//       dispatch({
//         type: actionTypes.PRODUCT_CATEGORY_GET,
//         productCategories,
//       });
//       return productCategories;
//     } catch (error) {
//       console.error("Error fetching product categories", error);
//     }
//   };
// }
export function getProductCategories(
  from = 0,
  size = 1000,
  searchText = "",
  status = "active"
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      // Build params dynamically
      const params = {
        from,
        size,
      };

      if (searchText !== "") {
        params.searchText = searchText;
      }

      if (status) {
        params.status = status;
      }

      const response = await axios.get(
        constants.API_URL + "/catalog/categories",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        }
      );
      

      let productCategories = [];
      let totalCount = 0;

      if (response.data.code === "0") {
        productCategories = response.data.productCategories;
        totalCount = response.data.pagination.totalCount || 0;
        
      } else {
              if (
          response &&
          response.hasOwnProperty("data") &&
          response.data.hasOwnProperty("message")
        ) {
          alert(response.data.message);
        } else {
          alert("Failed to load data");
        }

      }

      return { searchResult: productCategories, totalCount };

    } catch (error) {
      console.error("Error fetching product categories", error);
      return { searchResult: [], totalCount: 0 };
    }
  };
}
export function getAllProductCategoriesToRedux() {
  return async (dispatch) => {
    try {
      const pageSize = 1000; // Define a consistent page size
      let productCategories = [];
      
      // 1. Fetch the first page to get initial data and totalCount
      const firstPage = await dispatch(getProductCategories(0, pageSize));
      productCategories = [...firstPage.searchResult];
      
      const totalCount = firstPage.totalCount;

      // 2. If there are more items, loop through the remaining pages
      if (totalCount > pageSize) {
        const remainingPages = Math.ceil(totalCount / pageSize) - 1;
        
        for (let i = 1; i <= remainingPages; i++) {
          const offset = i * pageSize;
          const nextPage = await dispatch(getProductCategories(offset, pageSize));
          
          if (nextPage.searchResult) {
            productCategories = [...productCategories, ...nextPage.searchResult];
          }
        }
      }

      // 3. Dispatch the final complete list to Redux
      dispatch({
        type: actionTypes.PRODUCT_CATEGORY_GET,
        productCategories: productCategories,
      });

      console.log("productCategories",productCategories);

      return productCategories;
    } catch (error) {
      console.error("Error in getAllProductCategoriesToRedux:", error);
      return [];
    }
  };
}

export function getAllProductSubCategoriesToRedux() {
  return async (dispatch) => {
    try {
      const pageSize = 1000; // Define a consistent page size
      let productSubCategories = [];
      
      // 1. Fetch the first page to get initial data and totalCount
      const firstPage = await dispatch(getProductSubCategories(0, pageSize));
      productSubCategories = [...firstPage.searchResult];
      
      const totalCount = firstPage.totalCount;

      // 2. If there are more items, loop through the remaining pages
      if (totalCount > pageSize) {
        const remainingPages = Math.ceil(totalCount / pageSize) - 1;
        
        for (let i = 1; i <= remainingPages; i++) {
          const offset = i * pageSize;
          const nextPage = await dispatch(getProductSubCategories(offset, pageSize));
          
          if (nextPage.searchResult) {
            productSubCategories = [...productSubCategories, ...nextPage.searchResult];
          }
        }
      }

      // 3. Dispatch the final complete list to Redux
      dispatch({
        type: actionTypes.PRODUCT_SUB_CATEGORY_GET,
        productSubCategories: productSubCategories,
      });

      return productSubCategories;
    } catch (error) {
      console.error("Error in getAllProductSubCategoriesToRedux:", error);
      return [];
    }
  };
}
// export function getProductSubCategories() {
//   return async (dispatch, getState) => {
//     try {
//       const token = getState().user.uat;
//       const response = await axios.get(
//         constants.API_URL + "/catalog/subcategories",
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       const productSubCategories = response.data.productSubCategories;
//       dispatch({
//         type: actionTypes.PRODUCT_SUB_CATEGORY_GET,
//         productSubCategories,
//       });
//     } catch (error) {
//       console.error("Error fetching product sub categories", error);
//     }
//   };
// }

export function getProductSubCategories(
  from = 0,
  size = 1000,
  searchText = "",
  status = "active",
  parent = "",
  parentId = "",
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      // Build params dynamically
      const params = {
        from: from,
        size: size,
      };

      if (searchText !== "") {
        params.searchText = searchText;
      }

      if (status !== "") {
        params.status = status;
      }

      if (parent !== "") {
        params.parent = parent;
      }

      if (parentId !== "") {
        params.parentId = parentId;
      }

      const response = await axios.get(
        constants.API_URL + "/catalog/subcategories",
        {
          headers: {
            Authorization: "Bearer " + token,
          },
          params: params,
        }
      );

      let productSubCategories = [];
      let totalCount = 0;

      if (
        response &&
        response.hasOwnProperty("data") &&
        response.data.hasOwnProperty("code") &&
        response.data.code === "0"
      ) {
        if (response.data.hasOwnProperty("productSubCategories")) {
          productSubCategories = response.data.productSubCategories;
        }

        if (
          response.data.hasOwnProperty("pagination") &&
          response.data.pagination.hasOwnProperty("totalCount")
        ) {
          totalCount = response.data.pagination.totalCount;
        }
      } else {
        if (
          response &&
          response.hasOwnProperty("data") &&
          response.data.hasOwnProperty("message")
        ) {
          alert(response.data.message);
        } else {
          alert("Failed to load subcategories");
        }
      }

      return {
        searchResult: productSubCategories,
        totalCount: totalCount,
      };

    } catch (error) {
      console.error("Error fetching product subcategories", error);

      if (
        error &&
        error.hasOwnProperty("response") &&
        error.response.hasOwnProperty("data") &&
        error.response.data.hasOwnProperty("message")
      ) {
        alert(error.response.data.message);
      } else {
        alert("Something went wrong while fetching subcategories");
      }

      return {
        searchResult: [],
        totalCount: 0,
      };
    }
  };
}

export function checkIfProductCategoryIsUnique(category, categoryID) {
  return async (dispatch, getState) => {
    let query = {
      filters: [
        {
          field: "IsDeleted",
          operator: "exact",
          clause: "must",
          value: false,
        },
        {
          field: "Name",
          operator: "like",
          clause: "must",
          value: category.trim(),
        },
        {
          field: "ParentID",
          operator: "exact",
          clause: "must",
          value: "",
        },
      ],
      pagination: {
        from: 0,
        size: 200,
      },
      sort: [
        {
          field: "ActionOn",
          order: "desc",
        },
      ],
      returnFields: [],
    };
    if (categoryID !== "") {
      query.filters.push({
        field: "_id",
        operator: "exact",
        clause: "not",
        value: categoryID,
      });
    }
    const token = getState().user.uat;
    const response = await axios.post(
      constants.API_URL + "/catalog/category/search",
      query,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    // console.log("checkIfProductCategoryIsUnique", response);
    let unique = true;
    if (
      response.data &&
      response.data.productCategories &&
      response.data.productCategories.length > 0
    ) {
      response.data.productCategories.map((m) => {
        if (m.Name.toLowerCase() === category.toLowerCase()) {
          unique = false;
        }
      });
    }
    return unique;
  };
}

export function checkIfProductSubCategoryIsUnique(
  subCategory,
  categoryID,
  subCategoryID
) {
  return async (dispatch, getState) => {
    let query = {
      filters: [
        {
          field: "IsDeleted",
          operator: "exact",
          clause: "must",
          value: false,
        },
        {
          field: "Name",
          operator: "like",
          clause: "must",
          value: subCategory.trim(),
        },
        {
          field: "ParentID",
          operator: "exact",
          clause: "must",
          value: categoryID,
        },
      ],
      pagination: {
        from: 0,
        size: 200,
      },
      sort: [
        {
          field: "ActionOn",
          order: "desc",
        },
      ],
      returnFields: [],
    };
    if (subCategoryID !== "") {
      query.filters.push({
        field: "_id",
        operator: "exact",
        clause: "not",
        value: subCategoryID,
      });
    }
    const token = getState().user.uat;
    const response = await axios.post(
      constants.API_URL + "/catalog/category/search",
      query,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    // console.log("checkIfProductSubCategoryIsUnique", response);
    let unique = true;
    if (
      response.data &&
      response.data.productCategories &&
      response.data.productCategories.length > 0
    ) {
      response.data.productCategories.map((m) => {
        if (m.Name.toLowerCase() === subCategory.toLowerCase()) {
          unique = false;
        }
      });
    }
    return unique;
  };
}
